import { LeftMenuService } from '../../store/services/left-menu.service';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { IAccount } from '../../store/models/account.model';
import { AccountService } from '../../store/services/account.service';
import { ContactsService } from '../../store/services/contacts.service';
import { IUserSessionData, UserType } from '../../store/models/user.model';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { SessionService } from '../../store/services/session.service';
import {
  EFilterColumnTypes,
  EFilterSize,
  EFilterType,
  ETableColumnType,
  ITableColumn,
  ITableFIlterGroup,
} from '../../store/models/table.model';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { IContactGroup, IContactItem } from 'app/store/models/contact.model';
import { ButtonColor, ButtonSize, IButtonSelectItem } from 'app/store/models/button.model';
import { EInfoSelectItemType } from 'app/store/models/select.model';
import { DialogData } from 'app/store/models/dialog.model';
import { InfoTipsComponent } from 'app/dialogs/info-tips/info-tips.component';
import { ButtonSelectComponent } from 'app/shared/ui/button-select/button-select.component';
import { ApiDataSource } from 'app/datasources/api.datasrouce';
import { Store } from '@ngrx/store';
import { IReducers } from 'app/store/reducers';
import { openDialog, openSnackbar } from 'app/store/actions/page.action';
import { ContactActivityComponent } from 'app/dialogs/contact-activity/contact-activity.component';
import { environment } from '../../../environments/environment';
import { RContentComponent } from 'app/dialogs/quick-response/r-content.component';
import { updateLeftMenuCount } from 'app/store/actions/meeting.action';
import { TableComponent } from '../../shared/ui/table/table.component';
import { ManagerGroupSelectorComponent } from './manager-group-selector/manager-group-selector.component';
import { IUserContactGroup } from '../../store/models/user-group.model';
import { EmailPositionComponent } from './email-position/email-position.component';
import { MatRadioChange } from '@angular/material/radio';
import {
  CUSTOM_FILTER_TYPE_KEYWORD,
  CUSTOM_FILTER_TYPE_TAGS,
} from '../user-groups-listing/user-groups-listing.component';

@Component({
  selector: 'app-contacts-listing',
  templateUrl: './contacts-listing.component.html',
  styleUrls: ['./contacts-listing.component.scss'],
})
export class ContactsListingComponent implements OnInit, OnDestroy {
  @ViewChild('tableComponent') tableComponent: TableComponent;

  tableColumns: ITableColumn<IContactItem>[];

  dataSource: ApiDataSource<IContactItem>;

  tableDataSourceParams;

  tableReady: boolean;
  tagsFilter = [];
  searchFilter = '';

  tableFilterGroups: ITableFIlterGroup[] = [
    {
      filters: [
        {
          label: 'Show...',
          type: EFilterType.RADIO,
          emptyValue: 'all',
        },
      ],
    },
    {
      filters: [],
    },
  ];
  selectedTableFilter: 'keyword' | 'tags' = 'keyword';
  tagsFilterAvailble: boolean;
  groupName: string;
  totalContactsCount: number;
  sessionData: IUserSessionData;
  private availableTags: {
    size: EFilterSize;
    onFilterChange: (value) => void;
    label: string;
    type: EFilterType;
    items: any[]
  };
  private availableSearch = {
    type: EFilterType.SEARCH,
    size: EFilterSize.HALF,
    items: [
      {
        id: 'search',
        label: ' Enter the Keyword for Search',
        icon: 'search',
      },
    ],
    onFilterChange: value => {
      this.searchChange(value);
    },
  };
  private groups: IContactGroup[];

  private destroy$: Subject<boolean> = new Subject<boolean>();

  private availableAccounts: IAccount[] = [];

  private activeFilter: string;

  constructor(
    private sessionService: SessionService,
    private accountService: AccountService,
    private contactsService: ContactsService,
    private http: HttpClient,
    private activatedRoute: ActivatedRoute,
    private leftMenuService: LeftMenuService,
    private store: Store<IReducers>,
  ) {
  }

  ngOnInit() {
    this.leftMenuService.expand('contacts');
    this.groupName =
      this.activatedRoute.snapshot.queryParamMap.get('group_name');
    this.activeFilter = this.activatedRoute.snapshot.queryParamMap.get('filter');
    this.tableDataSourceParams = {
      page: 1,
      pageSize: 10,
      filters: {
        group_id: this.activatedRoute.snapshot.paramMap.get('id').toString(),
        status: this.activeFilter,
      },
    };

    this.accountService.getTags().subscribe(response => {
      this.availableTags = {
        label: 'Tags',
        type: EFilterType.TAGS,
        size: EFilterSize.HALF,
        items: [],
        onFilterChange: value => {
          this.tagChange(value);
        },
      };
      response.items.forEach(item => {
        this.availableTags.items.push({
          id: item.id,
          label: item.name,
          value: item.name,
        });
      });
      this.tagsFilterAvailble = true;
    });

    this.groupName =
      this.activatedRoute.snapshot.queryParamMap.get('group_name');
    this.dataSource = new ApiDataSource<IContactItem>(
      this.http,
      environment.apiUrl + `/v1/contacts`,
    );
    this.dataSource
      .onDataLoaded()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => (this.totalContactsCount = this.dataSource.totalCount));
    this.sessionService
      .onReady()
      .pipe(takeUntil(this.destroy$))
      .subscribe((sessionData: IUserSessionData) => {
        this.sessionData = sessionData;
        this.availableAccounts = null;
        this.contactsService
          .getContactGroups(sessionData.id)
          .subscribe(groups => {
            this.groups = groups;
            if (
              this.sessionData.user_type === UserType.PARTNER ||
              this.sessionData.user_type === UserType.MANAGER
            ) {
              this.loadManagerAccounts();
              return;
            }
            this.setTableColumns();
            this.changeTableFilters(null, this.selectedTableFilter);
          });
      });
  }

  loadManagerAccounts(): void {
    this.accountService
      .getAccountsBasicInfo(UserType.SINGLE_USER)
      .subscribe(result => {
        this.availableAccounts = result.items;
        this.setTableColumns();
      });
  }

  setTableColumns(): void {
    let columns: ITableColumn<IContactItem>[] = [
      {
        id: 'contact_firstname',
        title: 'Contact',
        sortable: true,
        asHtml: true,
        renderer: (element: IContactItem) => {
          if (!element.contact_firstname && !element.contact_lastname) {
            return `
                <div class='color__blue__primary'>
                  <span>${element.contact_email}</span>
                </div>
              `;
          }
          return `
                <div class='color__blue__primary'>
                  <span>${`${element.contact_firstname || ''} ${
            element.contact_lastname || ''
          }`}</span>
                </div>
              `;
        },
      },
      {
        id: 'contact_title',
        title: 'Title',
        sortable: true,
      },
      {
        id: 'contact_company',
        title: 'Company',
        sortable: true,
      },
      {
        id: 'email_position',
        title: 'Position',
        sortable: true,
        type: ETableColumnType.ANCHOR,
        anchorHandler: (column, row) =>
          this.store.dispatch(openDialog({
            dialogData: {
              content: EmailPositionComponent,
              componentData: {
                contactId: row.contact_id,
                userTimezone: this.sessionData.time_zone,
              },
              dialogWidth: '300px',
              title: 'Message dates',
              canClose: true,
              buttons: [{
                text: 'Ok',
                actAsClose: true,
                onClick: dialog => dialog.close(),
                color: ButtonColor.GREEN,
                size: ButtonSize.NORMAL,
              }],
            },
          })),
      },
      {
        id: 'group_name',
        title: 'Group',
        type: ETableColumnType.COMPONENT,
        componentProperties: {
          component: ManagerGroupSelectorComponent,
          mapData: {
            data: {
              instance: 'column',
            },
            groups: {
              instance: 'static',
              target: this.groups,
            },
          },
        },
      },
    ];

    if (
      this.sessionData.permissions &&
      this.sessionData.permissions.can_find_template
    ) {
      columns.push({
        id: 'response',
        title: 'Reply',
        type: ETableColumnType.COMPONENT,
        componentProperties: {
          component: ButtonSelectComponent,
          mapData: {
            attachToBody: {
              instance: 'static',
              target: true,
            },
            buttonProperties: {
              instance: 'static',
              target: {
                text: 'Reply',
                size: ButtonSize.SMALL,
                color: ButtonColor.ORANGE,
              },
            },
            selection: {
              instance: 'function',
              target: rowItem => {
                return selectItem => this.openItemDialog(rowItem, selectItem);
              },
            },
            items: {
              instance: 'function',
              target: (item: IContactItem) => {
                const targetItems: IButtonSelectItem[] = [
                  {
                    label: 'Opportunities',
                    type: EInfoSelectItemType.TYPE_LINK,
                    tag: 'main',
                    dialogContent: this.getDialogData('opportunities'),
                    children: [
                      {
                        label: 'Meetings',
                        tag: 'meeting',
                        type: EInfoSelectItemType.TYPE_LINK,
                        dialogContent: this.getDialogData('meeting'),
                      },
                      {
                        label: 'Order/Quote',
                        tag: 'order',
                        type: EInfoSelectItemType.TYPE_LINK,
                        dialogContent: this.getDialogData('order'),
                      },
                    ],
                  },
                  {
                    label: 'Cycle',
                    tag: 'cycle',
                    type: EInfoSelectItemType.TYPE_LINK,
                    dialogContent: this.getDialogData('cycle'),
                  },
                  {
                    label: 'Follow up',
                    tag: 'followup',
                    type: EInfoSelectItemType.TYPE_LINK,
                    dialogContent: this.getDialogData('follow_up'),
                  },
                  {
                    label: 'Inactive',
                    tag: 'inactive',
                    type: EInfoSelectItemType.TYPE_LINK,
                    dialogContent: this.getDialogData('inactive'),
                  },
                  {
                    label: 'Remove',
                    tag: 'remove',
                    type: EInfoSelectItemType.TYPE_LINK,
                    dialogContent: this.getDialogData('remove'),
                  },
                  {
                    label: 'Conversation',
                    tag: 'conversation',
                    type: EInfoSelectItemType.TYPE_LINK,
                    dialogContent: this.getDialogData('conversation'),
                  },
                  // {
                  //   label: 'Available',
                  //   tag:'available',
                  //   type: EInfoSelectItemType.TYPE_LINK,
                  // },
                  // {
                  //   label: 'Future',
                  //   tag:'future',
                  //   type: EInfoSelectItemType.TYPE_LINK,
                  // },
                  // {
                  //   label: 'Not Available',
                  //   tag:'not-available',
                  //   type: EInfoSelectItemType.TYPE_LINK,
                  // },
                  {
                    label: 'Send Email',
                    tag: 'send-email',
                    type: EInfoSelectItemType.TYPE_NORMAL,
                    value: 'send_email',
                    dialogContent: this.getDialogData('send_email'),
                  },
                  // {
                  //   label: 'Send To Campaign',
                  //   tag:'send-to-campaign',
                  //   type: EInfoSelectItemType.TYPE_NORMAL,
                  //   value: 'sent_to_campaign'
                  // },
                ];

                if (this.sessionData.user_type === UserType.SINGLE_USER) {
                  targetItems.push({
                    label: 'Enter Activity',
                    tag: 'enter_activity',
                    type: EInfoSelectItemType.TYPE_LINK,
                    dialogContent: this.getDialogData('enter_activity'),
                  });
                }

                if (
                  this.sessionData.user_type === UserType.SINGLE_USER &&
                  !item.active_for_campaigns
                ) {
                  targetItems.push({
                    label: 'Back to campaign',
                    type: EInfoSelectItemType.TYPE_NORMAL,
                    dialogContent: this.getDialogData('back_to_campaign'),
                    onClick: () => {
                      this.contactsService
                        .turnBackContactToCampaign(item.contact_id)
                        .subscribe(
                          result => {
                            if (result && result.success) {
                              this.store.dispatch(
                                openSnackbar({
                                  snackbarData: {
                                    data: {
                                      type: 'success',
                                      message: `Contact ${item.contact_firstname} ${item.contact_lastname} moved back to campaign`,
                                    },
                                    duration: 5000,
                                    verticalPosition: 'bottom',
                                  },
                                }),
                              );
                              this.tableComponent.refresh();
                            }
                          },
                          error =>
                            this.store.dispatch(
                              openSnackbar({
                                snackbarData: {
                                  data: {
                                    type: 'error',
                                    message: error.error,
                                  },
                                },
                              }),
                            ),
                        );
                    },
                  });
                }

                return targetItems;
              },
            },
          },
        },
      });
    }

    columns = [
      ...columns,
      {
        id: 'edit',
        title: 'Edit',
        type: ETableColumnType.BUTTON,
        headerAsPagination: true,
        getButtonProperties: (item: IContactItem) => {
          return {
            color: ButtonColor.ORANGE,
            size: ButtonSize.SMALL,
            text: item.account_id === this.sessionData.id ? 'Edit' : 'View',
            style: 'outline',
          };
        },
        route: (item: IContactItem) => `/user_contacts/${item.contact_id}/edit`,
      },
    ];

    columns = [
      ...columns,
      {
        id: 'activity',
        title: 'Activity',
        type: ETableColumnType.BUTTON,
        buttonProperties: {
          color: ButtonColor.GREEN,
          size: ButtonSize.SMALL,
          text: 'Activity',
          style: 'outline',
          onClick: (item: IContactItem) =>
            this.store.dispatch(
              openDialog({
                dialogData: {
                  title: `Contact History for ${item.contact_firstname} ${item.contact_lastname}`,
                  content: ContactActivityComponent,
                  componentData: {
                    contactId: item.contact_id,
                    contactReplayAction: item.action_name,
                  },
                  dialogMinWidth: '1000px',
                  canClose: true,
                },
              }),
            ),
        },
      },
    ];
    if (this.sessionData.user_type !== UserType.SINGLE_USER) {
      let column = null;
      if (this.sessionData.user_type === UserType.MASTER) {
        column = {
          id: 'account_firstname',
          title: 'Account Name',
          renderer: (element: IContactItem) => {
            return `${element.account_firstname} ${element.account_lastname}`;
          },
        };
      } else {
        column = {
          id: 'account_firstname',
          title: 'Rep-Name',
          type: ETableColumnType.SELECT,
          selectProperties: {
            label: 'Move to',
            confirmMessage: `Warning - you are about to move a contact group from one rep to another, The contact group will be moved to the new reps account and automatically assigned to no campaign, You can use the edit/merge feature to move the contact group to an existing or new campaign, All campaign positions and replay actions will remain intact and all history for the contacts will be moved`,
            onSelection: (value, table, row: IUserContactGroup) => {
              this.contactsService
                .moveContactToAccount(row.contact_id, value)
                .subscribe(
                  () => {
                    const targetAccount = this.availableAccounts.find(
                      a => a.account_id === value,
                    );
                    if (targetAccount) {
                      this.store.dispatch(
                        openSnackbar({
                          snackbarData: {
                            data: {
                              type: 'success',
                              message: `Contact moved to ${targetAccount.first_name} ${targetAccount.last_name}`,
                            },
                            duration: 5000,
                            verticalPosition: 'bottom',
                          },
                        }),
                      );
                    }
                    table.refresh();
                  },
                  error => {
                    if (
                      error &&
                      error instanceof HttpErrorResponse &&
                      error.status === 400 &&
                      error.error
                    ) {
                      this.store.dispatch(
                        openSnackbar({
                          snackbarData: {
                            data: {
                              type: 'error',
                              message: error.error,
                            },
                            duration: 5000,
                            verticalPosition: 'bottom',
                          },
                        }),
                      );
                    }
                  },
                );
            },
            buildItems: row => {
              if (!this.availableAccounts) {
                return [];
              }
              return this.availableAccounts.map(account => {
                return {
                  label: `${account.first_name} ${account.last_name}`,
                  value: account.account_id,
                  selected: row.account_id === account.account_id,
                };
              });
            },
          },
        };
      }

      if (column) {
        columns = [...columns, column];
      }
    }
    columns = [
      ...columns,
      {
        id: 'contact_vip',
        title: 'VIP',
        type: ETableColumnType.CHECKBOX,
        sortable: true,
        checkboxProperties: {
          disabled: !this.sessionData.vip_mode,
          label: 'Vip',
          Change: (val: IContactItem) =>
            this.contactsService
              .setContactVipStatus(val.contact_id, !val.contact_vip)
              .subscribe(res => {
                if (this.tableComponent) {
                  this.tableComponent.refresh();
                }
              }),
        },
      },
      {
        id: 'contact_status',
        title: 'Status',
        headerAsFilter: true,
        filterColumnType: EFilterColumnTypes.SELECT,
        selectProperties: {
          label: 'Status',
          items: [
            {
              label: 'All',
              value: 'all',
              selected: this.activeFilter === 'all',
            },
            {
              label: 'Active',
              value: 'active',
              selected: this.activeFilter === 'active',
            },
            {
              label: 'Not Active',
              value: 'inactive',
              selected: this.activeFilter === 'inactive',
            },
            {
              label: 'Bounced emails',
              value: 'bounced',
              selected: this.activeFilter === 'bounced',
            },
          ],
        },
        headerFilter: 'status',
        route: (element: IContactItem) => {
          if (element.contact_status === 'Inactive') {
          }
        },
      },
    ];

    if (this.sessionData.user_type === UserType.MASTER) {
      columns.push({
        id: 'delete_contact',
        title: 'Delete',
        type: ETableColumnType.BUTTON,
        buttonProperties: {
          color: ButtonColor.RED,
          size: ButtonSize.SMALL,
          text: 'Delete',
          onClick: (item: IContactItem) =>
            this.store.dispatch(
              openDialog({
                dialogData: {
                  content: `Contact will be permanently deleted from your list. All associated messages, campaign email records and reply positions will be removed. <br/> Are you sure you want to permanently delete contact ID ${item.contact_id}  with email address ${item.contact_email}?`,
                  title: `Delete contact ${item.contact_email} with ID ${item.contact_id}`,
                  buttons: [
                    {
                      text: 'Yes',
                      size: ButtonSize.NORMAL,
                      color: ButtonColor.RED,
                      onClick: dialog =>
                        this.contactsService
                          .deleteContact(item.contact_id)
                          .subscribe(
                            () => {
                              this.store.dispatch(
                                openSnackbar({
                                  snackbarData: {
                                    data: {
                                      message: 'Contact successfully deleted',
                                      type: 'success',
                                    },
                                  },
                                }),
                              );
                              this.dataSource.refresh();
                              dialog.close();
                            },
                            error =>
                              this.store.dispatch(
                                openSnackbar({
                                  snackbarData: {
                                    data: {
                                      message: error.error,
                                      type: 'error',
                                    },
                                  },
                                }),
                              ),
                          ),
                    },
                  ],
                  canClose: true,
                },
              }),
            ),
        },
      });
    }

    this.tableColumns = columns;

    this.tableReady = true;
  }

  openDialog(item, data) {
    this.store.dispatch(
      openDialog({
        dialogData: {
          title: data.label,
          content: RContentComponent,
          componentData: {
            data,
            contact_id: item.contact_id,
            item,
          },
          dialogMinWidth: '1000px',
          onClose: () => this.dataSource.refresh(),
          canClose: true,
          tips: ['cycle', 'followup', 'meeting', 'inactive', 'remove'].indexOf(data.tag) !== -1 ? 'send-update' : null,
          // buttons: [
          //   {
          //       text: 'Ok',
          //       actAsClose: true,
          //       color: ButtonColor.GREEN,
          //       size: ButtonSize.NORMAL,
          //   },
          //     {
          //         text: 'Close',
          //         actAsClose: true,
          //         color: ButtonColor.RED,
          //         size: ButtonSize.NORMAL,
          //         onClick: () => console.log('cska')
          //     }
          // ]
        },
      }),
    );

    console.log('show  dialog', item);
  }

  openSendEmailDialog(item, data) {
    this.store.dispatch(
      openDialog({
        dialogData: {
          title: data.label,
          content: RContentComponent,
          componentData: {
            data,
            contact_id: item.contact_id,
          },
          dialogMinWidth: '1000px',
          canClose: true,
          tips: ['cycle', 'followup', 'meeting', 'inactive', 'remove'].indexOf(data.tag) !== -1 ? 'send-update' : null,
          buttons: [
            {
              text: 'Ok',
              actAsClose: true,
              color: ButtonColor.GREEN,
              size: ButtonSize.NORMAL,
            },
            {
              text: 'Close',
              actAsClose: true,
              color: ButtonColor.RED,
              size: ButtonSize.NORMAL,
              onClick: () => console.log('cska'),
            },
          ],
        },
      }),
    );

    console.log('show send email dialog', item);
  }

  openAddToCampaignDialog(item, data) {
    this.store.dispatch(
      openDialog({
        dialogData: {
          title: data.label,
          content: RContentComponent,
          componentData: {
            data,
          },
          dialogMinWidth: '1000px',
          canClose: true,
          tips: ['cycle', 'followup', 'meeting', 'inactive', 'remove'].indexOf(data.tag) !== -1 ? 'send-update' : null,
          buttons: [
            {
              text: 'Ok',
              actAsClose: true,
              color: ButtonColor.GREEN,
              size: ButtonSize.NORMAL,
            },
            {
              text: 'Close',
              actAsClose: true,
              color: ButtonColor.RED,
              size: ButtonSize.NORMAL,
              onClick: () => console.log('cska'),
            },
          ],
          onClose: () => this.dataSource.refresh(),
        },
      }),
    );

    console.log('show campaign dialog', item);
  }

  openItemDialog(itemRow, selectedItem) {
    switch (selectedItem.tag) {
      case 'main':
        break;
      case 'got-it':
        this.contactsService
          .quickResponse({ contact_id: itemRow.contact_id }, 'okgotit')
          .subscribe(response => {
            this.store.dispatch(updateLeftMenuCount({ data: {} }));
          });
        break;
      // case 'send-mail':
      //   this.openSendEmailDialog(itemRow, selectedItem);
      //   break;
      case 'send-to-campaign':
        this.openAddToCampaignDialog(itemRow, selectedItem);
        break;
      default:
        this.openDialog(itemRow, selectedItem);
        break;
    }
  }

  getDialogData(type): DialogData {
    return {
      content: InfoTipsComponent,
      title: 'Tips',
      canClose: true,
      dialogMinWidth: '700px',
      componentData: {
        type,
      },
    };
  }

  ngOnDestroy() {
    this.destroy$.next(false);
  }

  searchChange(value) {
    this.searchFilter = value;
    this.tableReady = false;
    this.tableDataSourceParams.filters.search = this.searchFilter;
    this.tableReady = true;
  }

  tagChange(value) {
    if (!value) {
      return;
    }
    this.tagsFilter = value;
    this.tableDataSourceParams.filters.tags = this.tagsFilter.toString();
  }

  changeTableFilters($event?: MatRadioChange, forceTo?: string) {
    const value = $event?.value || forceTo;
    if (value === CUSTOM_FILTER_TYPE_TAGS) {
      // remove search
      this.tableFilterGroups[1].filters = this.tableFilterGroups[1].filters.filter(f => f.type !== EFilterType.SEARCH);
      this.tableFilterGroups[1].filters.unshift(this.availableTags);
    } else if (value === CUSTOM_FILTER_TYPE_KEYWORD) {
      // remove tags
      this.tableFilterGroups[1].filters = this.tableFilterGroups[1].filters.filter(f => f.type !== EFilterType.TAGS);
      this.tableFilterGroups[1].filters.unshift(this.availableSearch);
    }

    if (!forceTo) {
      this.resetFilters();
    }
  }

  resetFilters = () => {
    this.searchFilter = '';
    if (this.tableComponent) {
      this.tableComponent.applyFilter(this.availableSearch, '', 'search');
      this.tableComponent.applyFilter(this.availableTags, '', null, true);
    }
    this.tableDataSourceParams = {
      page: 1,
      pageSize: 10,
      sortDir: 'desc',
      sortAttr: 'id',
      filters: {},
    };
    this.dataSource = new ApiDataSource<IContactItem>(
      this.http,
      environment.apiUrl + `/v1/contacts`,
    );
  };
}
